export default [
  {
    path: '/backend/dashboard',
    name: 'Dashboard',
    meta: { layout: 'umwa' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/admin/dashboard/Dashboard.vue'),
  },
  {
    path: '/backend/account/password',
    name: 'changePassword',
    meta: { layout: 'umwa' },
    label: 'Passwort ändern',
    component: () => import('@/views/user/account/Password.vue'),
  },
  {
    path: '/backend/clinic',
    name: 'clinicOverview',
    meta: { layout: 'umwa' },
    label: 'Übersicht',
    component: () => import('@/views/admin/clinic/Overview.vue'),
  },
  {
    path: '/backend/clinic/edit/:clinicId?',
    name: 'clinicEdit',
    meta: { layout: 'umwa' },
    label: 'Edit',
    component: () => import('@/views/admin/clinic/AddOrEdit.vue'),
  },
  {
    path: '/backend/clinic/add/',
    name: 'clinicAdd',
    meta: { layout: 'umwa' },
    label: 'Neu',
    component: () => import('@/views/admin/clinic/AddOrEdit.vue'),
  },
  {
    path: '/backend/user',
    name: 'userOverview',
    meta: { layout: 'umwa' },
    label: 'Übersicht',
    component: () => import('@/views/admin/user/Overview.vue'),
  },
  {
    path: '/backend/user/edit/:userId?',
    name: 'userEdit',
    meta: { layout: 'umwa' },
    label: 'Bearbeiten',
    component: () => import('@/views/admin/user/AddOrEdit.vue'),
  },
  {
    path: '/backend/user/add/',
    name: 'userAdd',
    meta: { layout: 'umwa' },
    label: 'Neu',
    component: () => import('@/views/admin/user/AddOrEdit.vue'),
  },
  {
    path: '/backend/contact',
    name: 'contactOverview',
    meta: { layout: 'umwa' },
    label: 'Übersicht',
    component: () => import('@/views/admin/contact/Overview.vue'),
  },
  {
    path: '/backend/contact/edit/:contactId?',
    name: 'contactEdit',
    meta: { layout: 'umwa' },
    label: 'Bearbeiten',
    component: () => import('@/views/admin/contact/AddOrEdit.vue'),
  },
  {
    path: '/backend/contact/add',
    name: 'contactAdd',
    meta: { layout: 'umwa' },
    label: 'Neu',
    component: () => import('@/views/admin/contact/AddOrEdit.vue'),
  },
  {
    path: '/backend/mailingList',
    name: 'listOverview',
    meta: { layout: 'umwa' },
    label: 'Listen',
    component: () => import('@/views/admin/mailingList/Overview.vue'),
  },
  {
    path: '/backend/mailingList/edit/:listId?',
    name: 'listEdit',
    meta: { layout: 'umwa' },
    label: 'Bearbeiten',
    component: () => import('@/views/admin/mailingList/Edit.vue'),
  },
  {
    path: '/backend/list/add',
    name: 'listAdd',
    meta: { layout: 'umwa' },
    label: 'Neu',
    component: () => import('@/views/admin/user/AddOrEdit.vue'),
  },
  {
    path: '/backend/umfrage/forms',
    name: 'Formulare',
    meta: { layout: 'umwa' },
    component: () => import('@/views/umfrage/Forms.vue'),
  },
  {
    path: '/backend/anamnese/forms',
    name: 'Anamnese-Formulare',
    meta: { layout: 'umwa' },
    component: () => import('@/views/anamnese/Forms.vue'),
  },
  {
    path: '/backend/anamnese/allocations',
    name: 'Zuweisungen',
    meta: { layout: 'umwa' },
    component: () => import('@/views/anamnese/Allocations.vue'),
  },
  {
    path: '/backend/results/mainsurvey/analytics',
    name: 'Analytics',
    meta: { layout: 'umwa' },
    label: 'Hauptbogen',
    component: () => import('@/views/user/results/survey/main.vue'),
  },
  {
    path: '/backend/results/mainsurvey/comments',
    name: 'Comments',
    meta: { layout: 'umwa' },
    label: 'Anmerkungen',
    component: () => import('@/views/user/results/survey/comments.vue'),
  },
  {
    path: '/backend/processes/overview',
    name: 'Vorgänge',
    meta: { layout: 'umwa' },
    label: 'Vorgänge',
    component: () => import('@/views/user/processes/Overview.vue'),
  },
  {
    path: '/backend/waitlist/overview/:waitlistLocationId',
    name: 'Warteliste',
    meta: { layout: 'umwa' },
    label: 'Warteliste',
    component: () => import('@/views/user/waitlist/Overview.vue'),
  },
  {
    path: '/backend/waitlist/lastminute',
    name: 'Last-Minute',
    meta: { layout: 'umwa' },
    label: 'Last-Minute',
    component: () => import('@/views/user/waitlist/Lastminute.vue'),
  },
]
